// Dynamic way of checking if slot is being used and triggering callbacks as it uses a computed variable
import { get } from 'lodash';

export default {
  computed: {
    hasSlot() {
      return (slotName) => {
        return get(this.$scopedSlots, slotName) !== undefined;
      };
    },
  },
};